export const Users = [
  {
    id: 1,
    profilePicture: "/assets/mypic.jpg",
    username: "Mahmoud Khalid",
  },
  {
    id: 2,
    profilePicture: "/assets/ahamdy.jpg",
    username: "Ahmad Hamdy",
  },
  {
    id: 3,
    profilePicture: "/assets/said.jpg",
    username: "Mohamed Said",
  },
  {
    id: 4,
    profilePicture: "/assets/nasr.jpg",
    username: "Mohamed Nasr",
  },
  {
    id: 5,
    profilePicture: "/assets/mhosary.jpg",
    username: "Mohammmed Elhosary",
  },
  {
    id: 6,
    profilePicture: "/assets/eslam.jpg",
    username: "Eslam Ashraf",
  },
  {
    id: 7,
    profilePicture: "/assets/fady.jpg",
    username: "Fady El-Kazzaz",
  },
  {
    id: 8,
    profilePicture: "/assets/adel.jpg",
    username: "Adel Hamada",
  },
  {
    id: 9,
    profilePicture: "/assets/shabdo.jpg",
    username: "Abdo Alminshawy",
  },
  {
    id: 10,
    profilePicture: "/assets/normal.jpg",
    username: "Muhammed Ali",
  },
];
export const Posts = [
  {
    id: 1,
    desc: "الفرق بين إما و أما و أما",
    photo: "/assets/posts/advice.jpg",
    date: "5 min ago",
    userId: 1,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    desc: "bed of programmers",
    photo: "/assets/posts/bedcode.jpg",
    date: "15 min ago",
    userId: 2,
    like: 17,
    comment: 1,
  },
  {
    id: 3,
    desc: "When you see a man focusing in paper",
    photo: "/assets/posts/enmem.jpg",
    date: "11 hour ago",
    userId: 3,
    like: 11,
    comment: 2,
  },
  {
    id: 4,
    desc: "when a customer says to you that I found someone else who do your work and less price",
    photo: "/assets/posts/famous.jpg",
    date: "5 hour ago",
    userId: 4,
    like: 27,
    comment: 0,
  },
  {
    id: 5,
    photo: "/assets/posts/mems.jpg",
    date: "33 min ago",
    userId: 5,
    like: 16,
    comment: 27,
  },
  {
    id: 6,
    photo: "/assets/posts/poet.jpg",
    date: "12 min ago",
    userId: 6,
    like: 31,
    comment: 3,
  },
  {
    id: 7,
    photo: "/assets/posts/pray.jpg",
    date: "50 min ago",
    userId: 7,
    like: 12,
    comment: 17,
  },
  {
    id: 8,
    desc: "single is gentle",
    photo: "/assets/posts/single.jpg",
    date: "3 hours ago",
    userId: 8,
    like: 22,
    comment: 2,
  },
  {
    id: 9,
    desc: "You need to achieve success",
    photo: "/assets/posts/success.jpg",
    date: "1 hour ago",
    userId: 9,
    like: 3,
    comment: 19,
  },
  {
    id: 10,
    photo: "/assets/posts/weakness.jpg",
    date: "3 hours ago",
    userId: 10,
    like: 2,
    comment: 10,
  },
];
